// --------------------------------------------------------------------------
// Standard Content Page
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function init() {
        /**
         * Loop through ask modules
         */
        context.find('.ask-block, .downloads-block').each(function () {
            var jqCurrentAskBlock = $(this);

            //Get offset of each module
            var offsetTop = jqCurrentAskBlock.offset().top,
                windowHeight = $(window).height();

            if (window.parent.epi) {
                jqCurrentAskBlock.addClass('enter');
            } else {
                $(window).scroll(function () {
                    //Initialise module entrance animation
                    if ($(document).scrollTop() >= offsetTop - windowHeight) {
                        jqCurrentAskBlock.addClass('enter');
                    }
                });
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/standard-content-reveal.js
// module id = 195
// module chunks = 0